import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	pageStatus: {
		id: 'search-page.filters.names.pageStatus',
		defaultMessage: 'Status',
		description: 'Label for filtering by page status for confluence',
	},
});
